<template>
  <div v-if="home" class="home">
    <!-- <span>약관 및 정책</span> -->
    <span class="title">솔닥 서비스 이용에 대한<br/> 약관 및 정책 확인이 가능해요</span>
    <div class="box" v-for="(content, index) in contents" @click="change(content.id)" v-if="content.id < 12">
        <span>{{ content.title }}</span>
        <img class="arrow" src="../assets/icn.png" />
    </div>
  </div>
  <router-view v-else />
</template>

<script>
import Constant from '@/constant';

export default {
    name: 'policy',
    data: function()
    {
        return {
            home: false,
            contents: null
        }
    },
    mounted: function()
    {
        if(this.$route.fullPath === '/')
        {
            this.$store.dispatch(Constant.FETCH_CATEGORIES)
                .then((res) => {
                    this.home = true;
                    this.contents = res;
                })
                .catch(() => {

                })        
        }      
        else
        {
            this.home = false;
        }
    },
    methods: {
        change: function(view)
        {
            this.home = false;

            if(view === 1)
            {
                this.$router.push({name: 'terms'})
            }
            else if(view === 2)
            {
                this.$router.push({name: 'privacy'})
            }
            else if(view === 3)
            {
                this.$router.push({name: 'marketing'})
            }
            else if(view === 4)
            {
                this.$router.push({name: 'use'})
            }
            else if(view === 5)
            {
                this.$router.push({name: 'location'})
            }
            else if(view === 6)
            {
                this.$router.push({name: 'innovation'})
            }
            else if(view === 7)
            {
                this.$router.push({name: 'challenge-terms'})
            }
            else if(view === 8)
            {
                this.$router.push({name: 'challenge-privacy'})
            }
            else if(view === 9)
            {
                this.$router.push({name: 'anzeilax-third-party'})
            }
            else if(view === 10)
            {
                this.$router.push({name: 'anzeilax-tech-consent'})
            }
            else if(view === 11)
            {
                this.$router.push({name: 'innovation-somzz'})
            }
        }
    },
    watch: {
        $route(to, from) {

            if(from.fullPath !== '/')
            {
                this.$store.dispatch(Constant.FETCH_CATEGORIES)
                .then((res) => {
                    this.home = true;
                    this.contents = res;
                })
                .catch(() => {

                })        
            }
            else
            {
                this.home = false;
            }
        }
    }
    
}
</script>

<style scoped>
    .home {
        display: flex;
        flex-direction: column;
    }
    .title {
        font-size: 20px;
        font-weight: bold;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .box {
        height: 65px;
        border-bottom: 1px solid #E8EAEE;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }
    .arrow {
        width: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Policy.vue